import { Ii18n } from '../contracts/i18n.interface';

const deviceTypes = {
  WEB: 'WEB',
  MOBILE: 'MOBILE'
};

const i18nCache: { [key: string]: Ii18n } = {};
const i18nReportCache: { [key: string]: Ii18n } = {};

const initWebI18n = (i18n: Ii18n) => {
  i18nCache[deviceTypes.WEB] = i18n;
};

const initMobileI18n = (i18n: Ii18n) => {
  i18nCache[deviceTypes.MOBILE] = i18n;
};

const initWebI18nReport = (i18n: Ii18n) => {
  i18nReportCache[deviceTypes.WEB] = i18n;
};

const initMobileI18nReport = (i18n: Ii18n) => {
  i18nReportCache[deviceTypes.MOBILE] = i18n;
};

const getI18n = (): Ii18n => {
  if (typeof document !== 'undefined') {
    return i18nCache[deviceTypes.WEB];
  } else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return i18nCache[deviceTypes.MOBILE];
  } else {
    throw new Error('Nodejs environment is not supported');
  }
};

const getI18nReport = (): Ii18n => {
  if (typeof document !== 'undefined') {
    return i18nReportCache[deviceTypes.WEB];
  } else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return i18nReportCache[deviceTypes.MOBILE];
  } else {
    throw new Error('Nodejs environment is not supported');
  }
};

export { initWebI18n, initMobileI18n, getI18n, getI18nReport, initWebI18nReport, initMobileI18nReport };
